import type { IMonitoringResult } from "@gearbox-protocol/cli-utils";
import {
  ErrorBox,
  Loading,
  MonitoringDashboard,
} from "@gearbox-protocol/deploy-tools-ui";
import { api } from "api";
import GrafanaLink from "components/GrafanaLink";
import type { FC } from "react";
import { useAsync } from "react-use";

const MonitoringRoute: FC = () => {
  const { value, loading, error } = useAsync(
    async (): Promise<IMonitoringResult> => {
      return api.getMonitoringData();
    },
  );

  if (loading) {
    return <Loading />;
  }

  if (error) {
    return <ErrorBox error={error} />;
  }

  if (!value) {
    return <ErrorBox error="No data" />;
  }

  return <MonitoringDashboard data={value} linkComponent={GrafanaLink} />;
};

export default MonitoringRoute;
